import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },
  title: {
    color: theme.colors.primary,
  },
  table: {
    textAlign: 'center',
    border: `1px solid ${theme.colors.iron}`,
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },
  tableContainer: {
    maxHeight: '600px',
  },
  borderRight: {
    borderRight: `1px solid ${theme.colors.iron}`,
  },
  tableHead: {
    background: '#F8F8F8',
  },
  tableHeaderCell: {
    width: '100px',
  },
  firstTableHeaderCell: {
    maxWidth: '200px',
    minWidth: '150px',
  },
  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },
  padding4: {
    padding: '4px',
  },
  liveChannel: {
    color: theme.colors.primary,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
  },
  disabledChannel: {
    color: '#848484',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
  },
}

export default styles
